import React, {useState } from 'react'
import classNames from 'classnames'
import flagMaroc from '../../assets/flageMACDestination.svg'
import flagTunisie from '../../assets/flageTUNDestination.svg'
import flagAlge from '../../assets/flegALGDestination.svg'
import flagPKR from '../../assets/flagPaksDestination.svg'
import flagTRY from '../../assets/flagTurkDestination.svg'
import flagBDT from '../../assets/flagBangDestination.svg'
import flagPHL from '../../assets/flagPhilippinesDestination.svg'
import FlagNGA from '../../assets/flagNigeriDestination.svg'
import flagSenegal from '../../assets/flagSENDestination.svg'
import flagKEN from '../../assets/flagkenyaDestination.svg'
import IconModale from '../../assets/iconModalCountrySelection.svg'
import IdentityCheckIcon from '../../assets/identityCheckIcon.svg'
import { useLocation } from 'react-router'

interface props {
  isOpen: boolean

  updateCountryUser: any
  setDestinationDefaultCountry: (value: string) => void
  destinationDefaultCountry:string
}

 
const ModalSowCountry: React.FC<props> = ({
  isOpen,
  updateCountryUser,
  setDestinationDefaultCountry,
  destinationDefaultCountry
}) => {
  const location = useLocation()
  const [operateur, setOperateur] = useState('')
  const [isClicked, setIsClicked] = useState(false)

  if (
    !isOpen ||
    location.pathname === '/publicpayment' ||
    location.pathname === '/login' ||
    location.pathname === '/signup' ||
    location.pathname === '/forgotPassword' ||
    location.pathname.includes('/reset-pass') ||
    location.pathname.includes('/activation')
  )
    return null


 
  const  listePays=[
    {flag: flagMaroc, code:'MAC' ,nom:'Maroc', operateur:'MC' },
    {flag: flagTunisie, code:'TUN' ,nom:'Tunisie', Operateur:'TN' },
    {flag: flagSenegal, code: 'SEN', nom: 'Sénégal', Operateur:'XOF'},
    // {flag: flagAlge , code: 'DZA', nom: 'Algérie', Operateur:'DZ'},
    {flag: flagPKR , code: 'PKR', nom: 'Pakistan', Operateur:'PKR'},
    {flag: flagTRY , code: 'TRY', nom: 'Turquie', Operateur:'TRY'},
    {flag: flagBDT , code: 'BDT', nom: 'Bangladesh', Operateur:'BDT'}, 
    {flag: FlagNGA , code: 'NGA', nom: 'Nigeria', Operateur:'NGN'}, 
    {flag: flagKEN , code: 'KEN', nom: 'Kenya', Operateur:'KES'}, 
    {flag: flagPHL , code: 'PHL', nom: 'Philippines', Operateur:'PHP'}, 
  ]

  return (
    <div className={classNames(
        'fixed justify-center items-center flex flex-col inset-0 z-50 bg-[#5754E5]/60 backdrop-blur-[5px] sm:px-[20px] will-change-[backdrop-filter] [@supports(-webkit-backdrop-filter:blur(5px))]:[-webkit-backdrop-filter:blur(5px)] ',
      )}
    >
        <div
          className={classNames(
            ' font-roboto font-medium rounded-[24px] shadow-[0_2px_8px_rgba(0,0,0,0.25)] w-[350px] sm:w-full  py-10 px-[24px] relative flex flex-col items-center justify-center bg-white',
          )}
        > 
        <img src={IconModale} alt='Country selection modal icon'/>
        <h1 className=' font-bold text-[22px] text-[#2D2A66] mt-2 mb-9'>C’est presque fini !</h1>

        {!destinationDefaultCountry ?
          <div>

            <div className="text-center font-normal pb-3 mt-5 text-[16px] text-[#666666]">Choisissez votre pays de destination</div>
            <div className='grid grid-cols-2 gap-[35px] sm:gap-[25px] mt-5 max-h-[250px] overflow-y-auto scrollbar-webkit'>
            {listePays.map((item, index)=>(
              <div key={index} >
          
                <img
                onClick={() => {
                  setDestinationDefaultCountry(item.code)
                  setOperateur(item.nom)
                  setIsClicked(true)
                }}
                  src={item.flag}
                  width={110}
                  height={110}
                  alt="pays de destination: Tunisie"
                  className={` object-cover rounded-full cursor-pointer sm:w-[90px] h-auto ${operateur ? operateur === item.nom ? 'border-[3px]  border-[#5754E5]' : 'opacity-70' : ''} `}
                />

              </div>
            ))}
          </div>
          </div>
        :
        <div className='flex flex-col gap-[24px] items-center w-full'>
        <div className='flex items-center justify-between w-full px-4'> 
          <span className='text-[#422EAE] text-[14px]'>Mon pays :</span>
          <div
           onClick={()=>{
              setDestinationDefaultCountry('')
              // setOperateur('')
           }}
           className=' cursor-pointer rounded-full border border-[#AEB6FB] bg-[#F1F1FF]  h-[51px] flex justify-between items-center px-3'>
            <img  className='w-[35px] h-auto' src={listePays.find((item)=>item.nom === operateur)?.flag} alt=''/>
            <span className='text-[#35258B] text-[16px]'>{operateur}</span>
          </div>
        </div>
          <div className=' text-center text-[#6B7280] text-[16px]'>Et maintenant vérifiez votre identité pour assurer votre sécurité</div>
          <button onClick={()=>{
                setIsClicked(false)
                updateCountryUser(true)}
             }
             disabled={isClicked=== false}
              className='bg-[#5754E5] rounded-[16px] cursor-pointer w-full  py-2 h-[100px] flex flex-col items-center justify-between'>
            <img src={IdentityCheckIcon} alt=''/>
            <h3 className='font-bold text-[#FFF]'>Vérifier mon identité</h3>
          </button>
          <button onClick={()=>{
                setIsClicked(false)
                updateCountryUser(false)
              }
            } 
            disabled={isClicked===false}
             className='text-[#5754E5] font-bold cursor-pointer'>Passer</button>

        </div>
       }
  
        </div>
    </div>
  )
}
export default ModalSowCountry
